var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.143C0 .51.536 0 1.2 0h9a1.2 1.2 0 011.118.729c.18.439.056.939-.308 1.257l-4.924 4.3H6.9c2.816 0 5.1 2.175 5.1 4.857C12 13.825 9.716 16 6.9 16H3.952C2.362 16 .909 15.143.2 13.79l-.072-.136c-.296-.565-.056-1.25.537-1.533.592-.282 1.312-.053 1.608.511l.072.136c.304.582.93.946 1.609.946H6.9c1.492 0 2.7-1.15 2.7-2.571C9.6 9.72 8.393 8.57 6.9 8.57H3a1.2 1.2 0 01-1.117-.728c-.18-.44-.057-.94.307-1.257l4.924-4.3H1.2c-.664 0-1.2-.511-1.2-1.143z",
    fill: "#00B9EF"
  })));
}

export default SvgThree;